// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Eex6","inputWrap":"styles_inputWrap__20YqR","input":"styles_input__2Mm2Y"};